module.exports = __webpack_public_path__ + "static/assets/about3.23608275.jpg";